// io-branding B.7 — build-time component theme selection.
//
// Icarus auto-registers components in three tiers, highest precedence first:
//
//   ICARUS_THEME (src/themes/<name>/)  >  project (src/components/)  >  core (@apexl/icarus-core)
//
// A theme is a SELECTIVE set of component overrides chosen at build time via
// the ICARUS_THEME env. `require.context('./themes', true, …)` bundles every
// theme's files (the directory part of require.context must be static), so we
// filter the keys down to just the active theme's at registration time. When
// ICARUS_THEME is empty, no theme is active and the loader is a no-op.

/**
 * Filter a require.context key list to just the active theme's files.
 *
 * Keys look like "./reference/ThemeMarker.vue"; the active theme claims
 * everything under "./<activeTheme>/".
 *
 * @param {string[]} keys         require.context('./themes', …).keys()
 * @param {string}   activeTheme  the ICARUS_THEME value ('' = none)
 * @returns {string[]} the subset of keys belonging to the active theme
 */
export function activeThemeKeys(keys, activeTheme) {
  if (!activeTheme) {
    return [];
  }
  const prefix = `./${activeTheme}/`;
  return (keys || []).filter(k => typeof k === 'string' && k.startsWith(prefix));
}
